import type { MakeRequest, Plugin, Request } from '@tinkoff/request-core';
import request from '@tinkoff/request-core';
import http from '@tinkoff/request-plugin-protocol-http';
import validate from '@tinkoff/request-plugin-validate';

import { TinkoffRequestScpPlugin } from '@breezeventures/scp-client';

import { getUrlFromParams } from './get-url-from-params';

import type { ScpClient } from '..';
import { ResponseFormatError } from '../../../errors/error';
import type { ResponseSuccess } from '../../response/response';
import { isScpResponse } from '../../response/response';
import type { RequestParams } from '../request-params';

interface Options {
  plugins?: Plugin[];
}

export class WebRequestClient implements ScpClient {
  makeRequest: MakeRequest;

  constructor(options: Options = {}) {
    this.makeRequest = request([
      ...(options.plugins ?? []),
      TinkoffRequestScpPlugin(),
      validate({
        validator({ response }) {
          if (!isScpResponse(response)) {
            return new ResponseFormatError(response);
          }
          return;
        },
      }),
      http(),
    ]);
  }

  call<T>(params: RequestParams): Promise<ResponseSuccess<T>> {
    const url = getUrlFromParams(params);

    const requestParams: Request = {
      httpMethod: 'POST',
      type: params.type ?? 'json',
      url,
      timeout: params.timeout ?? 60 * 1000,
    };

    if ('payload' in params) {
      requestParams.payload = params.payload;
    }

    if ('headers' in params) {
      requestParams.headers = params.headers;
    }

    if ('withCredentials' in params) {
      requestParams.withCredentials = params.withCredentials;
    }

    return this.makeRequest(requestParams);
  }
}
